import { apiSlice } from '../../../../app/apiSlice';
import { formatDateToISO } from '../../../../utils/formatDate';
import configSiteUrls from '../../configs/configSiteUrls';
import { OuvidoriaListPublicResponse } from './types/Ouvidoria';
import { OuvidoriaAnexo } from './types/OuvidoriaAnexo';

//usei o ouvidoriaAnexo como base

const endpointUrl = configSiteUrls.SITE_OUVIDORIA_EP;
const endpointUrlPublic = configSiteUrls.SITE_OUVIDORIA_PUBLIC_EP;

interface Params {
  data_inicial?: string | null;
  data_final?: string | null;
  search?: string | null;
  page?: number;
  apply?: boolean;
  exercicio?: string | null;
  tipo?: string | null;
}

function getouvidoriasPublic({ data_inicial, data_final, search, page = 1, exercicio, tipo }: Params) {
  const queryParams = new URLSearchParams();

  if (search) queryParams.set('search', search);
  if (data_inicial) queryParams.set('dataInicial', formatDateToISO(data_inicial));
  if (data_final) queryParams.set('dataFinal', formatDateToISO(data_final));
  queryParams.set('page', page.toString());
  if (exercicio) queryParams.set('exercicio', exercicio);
  if (tipo) queryParams.set('tipo', tipo);

  return {
    url: `${endpointUrlPublic}/all?${queryParams.toString()}`,
    method: 'GET'
  };
}

function getOuvidoriaAnexos({ idOuvidoriaAnexo }: { idOuvidoriaAnexo: string }) {
  if (!idOuvidoriaAnexo) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrlPublic}/anexos?idn=${idOuvidoriaAnexo}&respostaAnexo=false`,
    method: 'GET'
  };
}

function getOuvidoriaAnexosResposta({ idOuvidoriaAnexo }: { idOuvidoriaAnexo: string }) {
  if (!idOuvidoriaAnexo) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrlPublic}/anexos?idn=${idOuvidoriaAnexo}&respostaAnexo=true`,
    method: 'GET'
  };
}

function addAnexos(formData: FormData) {
  return {
    url: `${endpointUrlPublic}/anexos/create`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

//addAnexosResposta
function addAnexosResposta(formData: FormData) {
  return {
    url: `${endpointUrl}/anexos/create`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

function removeAnexosExcluidos(formData: FormData) {
  return {
    url: `${endpointUrl}/remover-anexos`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

export const ouvidoriaAnexoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getOuvidoriaAnexos: query<OuvidoriaAnexo[], { idOuvidoriaAnexo: string }>({
      query: getOuvidoriaAnexos,
      providesTags: ['OuvidoriaAnexoSite']
    }),
    getOuvidoriaAnexosResposta: query<OuvidoriaAnexo[], { idOuvidoriaAnexo: string }>({
      query: getOuvidoriaAnexosResposta,
      providesTags: ['OuvidoriaAnexoSite']
    }),
    getouvidoriasPublic: query<OuvidoriaListPublicResponse, Params>({
      query: getouvidoriasPublic,
      providesTags: ['OuvidoriaAnexoSite']
    }),

    addOuvidoriaAnexos: mutation<void, FormData>({
      query: addAnexos,
      invalidatesTags: ['OuvidoriaAnexoSite']
    }),
    addOuvidoriaAnexosResposta: mutation<void, FormData>({
      query: addAnexosResposta,
      invalidatesTags: ['OuvidoriaAnexoSite']
    }),
    removeOuvidoriaAnexoExcluido: mutation<void, FormData>({
      query: removeAnexosExcluidos,
      invalidatesTags: ['OuvidoriaAnexoSite']
    })
  })
});
export const {
  useGetOuvidoriaAnexosQuery,
  useAddOuvidoriaAnexosMutation,
  useRemoveOuvidoriaAnexoExcluidoMutation,
  useLazyGetOuvidoriaAnexosQuery,
  useGetOuvidoriaAnexosRespostaQuery,
  useGetouvidoriasPublicQuery,
  useLazyGetouvidoriasPublicQuery,
  useAddOuvidoriaAnexosRespostaMutation
} = ouvidoriaAnexoApiSlice;
